import {Flex} from '@chakra-ui/react';
import React from 'react';
import MembershipHeaderCard from './MembershipHeaderCard';
import {MembershipPlan} from "../../endpoints/interfaces/membershipPlan";

interface HeaderProps {
  memberships: MembershipPlan[];
  selectedMembershipId: number | undefined;
  setSelectedMembershipId: (id: number | undefined) => void;
  isAnnualPaymentSelected: boolean;
  setIsAnnualPaymentSelected: (isAnnual: boolean) => void;
}
const Header = ({
  memberships,
  selectedMembershipId,
  setSelectedMembershipId,
  isAnnualPaymentSelected,
  setIsAnnualPaymentSelected
}: HeaderProps) => {

  return (
    <>
      <Flex
        gap="10px"
        position="relative"
        // top="-65px"
        // width="90%"
        // marginLeft="5%"
        mt="20px"
        transform="auto"
        // marginBottom="-6.5rem"
        flexDirection="row"
        justifyContent="center">
        {memberships.map((membership, i) => {
          if (membership.id == 1) return null;
          return (
            <MembershipHeaderCard
              key={i}
              membership={membership}
              selectedMembershipId={selectedMembershipId}
              setSelectedMembershipId={setSelectedMembershipId}
              isAnnualPaymentSelected={isAnnualPaymentSelected}
              setIsAnnualPaymentSelected={setIsAnnualPaymentSelected}
            />
          );
        })}
        {/* <TextA18 fontWeight="700">Walkabout Membership</TextA18>
        <HStack justifyContent="space-between">
          <TextG12>A short subtitle comes here</TextG12>
          {lowestPrice && lowestPrice > 0 && (
            <TextG12>{`From ${numberToCurrency(lowestPrice)}/mo`}</TextG12>
          )}
        </HStack> */}
      </Flex>
    </>
  );
};

export default Header;
